<template>
	<div class="multi-quiz__button btn btn-progres" @click="onClick" :class="{'answered' : answer.answer != -1 , 'answered-current' : answer.question == question}">
		<div class="checkboxHolder">
			
		</div>
		<div class="btn__content">{{text}}</div>
	</div>
</template>

<script>
	export default {

		props: [
			'index',
			'answer',
			'question',
			'onClick',
			'text',
		],

		data(){
			return{
			}
		},

		mounted(){
		},

		watch:{
		},

		computed: {

		},

		methods:{
		},

	}
</script>


// WEBPACK FOOTER //
// src/components/minigames/matchingquiz/Button.vue